<template>
  <div :style="{ direction: directionStyle }" :class="{ar: directionStyle === 'rtl'}">
    <div class="content" :class="{ 'pwa-content': pwaFlag }">
      <div class="user-account-info" :class="{ 'pwa-user-account-info': pwaFlag }">
      
        <div class="" v-if="userInfo">
          <!--          不展示了
                  <p class="recharge_title">{{ $t("m.Diamonds_title") }}</p>
                    -->
          <div class="check-account fc-space-between" style="margin-bottom: 0;" :style="{ display: pwaFlag ? 'none' : 'flex' }">
            <div></div>
            <img src="static/img/question.png" alt="" @click="showIdDesc = true">
          </div>
          <div class="user-info-bar" :style="{ display: pwaFlag ? 'none' : 'flex' }">
            <van-image class="user_photo" :src="userInfo.img || './../assets/default.png'">
              <template v-slot:error>
                <img class="user_photo" src="./../assets/default.png"/>
              </template>
            </van-image>
            <div class="user-info">
              <p class="user-name fc-elip-1" style="max-width: 3rem" v-cloak>
              {{ userInfo.nickName }}
            </p>
              <p class="user-id" v-cloak>
              ID:{{ userInfo.userId }}
            </p>
          </div>
            <!-- 替换账号按钮 有值以及非渠道包的时候才展示 -->
            <div
              v-if="!hideReplaceBtn && userInfo.userId"
              class="sure-btn"
              @click="replaceAccount">
            {{ $t("m.replace") }}
          </div>
        </div>
      </div>

        <!--       no account -->
        <div class="" v-else>
          <div class="check-account fc-space-between" :style="{ display: pwaFlag ? 'none' : 'flex' }">
            <p>
              {{ $t("m.check-account") }}
            </p>
            <img src="static/img/question.png" alt="" @click="showIdDesc = true">
          </div>
          <div class="fc-space-between fc-flex-vcenter">
          <input
            class="input_trans"
            type="text"
            :placeholder="$t('m.EnterID')"
            v-model="userId"
            @input="filterInput"
          />
            <div class="sure-btn" @click="getUserInfo(1)">
            {{ $t("m.sureBtn") }}
          </div>
        </div>
      </div>
        <!--
         <div
                class=" fc-text-center fc-text-sm fc-color-gray-light"
                @click="showIdDesc = true"
              >
                {{ $t("m.whatID") }}
              </div>
              -->
      </div>

      <div class="recharge" :class="{ 'pwa-recharge': pwaFlag }">

      <div class="recharge-title-bar  fc-space-between">
        <div class="tabs">
          <span class="item" >
            {{ $t("m.payforType") }}
          </span>
        </div>
        <div
          class="select-local"
          @click="showcountryPicker = true"
          v-if="selCountryInfo.content"
          v-cloak
        >
          <img src="static/img/cz_location.png" alt="" class="local-icon"/>
          <span>{{ selCountryInfo.content }}</span>
          <img src="static/img/arrow.png" alt="" class="arrow-icon"/>
        </div>
      </div>

    

      <van-collapse
        v-model="activePayIndex"
        accordion
        class="payStyleCon"
        v-if="payStyleArr"
      >
        <van-collapse-item
          :name="index"
          v-for="(item, index) in payStyleArr"
          :key="'pay' + index"
        >
          <template #title>
            <div class="fc-flex fc-flex-vcenter">
              <span class="payStyleIcon">
                <img :src="item.rechargePayType.payTypeImg" />
              </span>
              <span class="fc-flex1 pay-type-name">{{
                item.rechargePayType.payTypeName
              }}</span>
            </div>
          </template>
          <!--          <template #right-icon>
                      <img src="static/img/arrow_2.png" alt="" class="arrow-icon"/>
                    </template>-->
          <div
            class="buyInfoItem"
            v-for="(son, index) in item.rechargeNormList"
            :key="'paymoney' + index"
          >
            <img class="diamond_icon" src="static/img/diamond.png" />
            <div class="fc-flex fc-flex-vcenter fc-flex1">
              <span class="buyNum">{{ son.newNumber }}</span>
              <span class="morereward_txt" v-if="son.awardNumber > 0"
                >+{{ son.awardNumber }}</span
              >
              <img class="morereward_img" :src="son.img" v-if="son.img"/>
            </div>
            <div
              class="payBtn"
              v-if="selCountryInfo.coding == 'CN'"
              @click="payforMoney(item.rechargePayType, son)"
            >
              ￥<span>{{ son.price_China }}</span>
            </div>
            <div
              class="payBtn"
              v-else
              @click="payforMoney(item.rechargePayType, son)"
            >
              $<span>{{ son.price_America }}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>

      </div>

    </div>
    <p class="buy-notice" v-html="moreLang.buyNoticeA"></p>
    <p class="ask-tip">
      <img src="static/img/question_icon.png" class="fc-icon-sm"/>
      <a href="#/asks" class="">{{ $t("m.rechargeFAQ_title") }}</a>
    </p>
  
    <van-popup
      v-model="showIdDesc"
      closeable
      overlay-class="fcId_mask"
      class="question-popup"
    >
      <div class="mask-content">
        <p class="">
          {{ $t("m.openAPP") }}
        </p>
        <img src="static/img/findID.png" alt=""/>
      </div>
    </van-popup>
    <van-popup v-model="showcountryPicker" round position="bottom" class="country-popup-picker">
      <van-picker
        show-toolbar
        class="country-picker"
        :default-index="currentCountryIndex"
        :loading="countryLoading"
        :confirm-button-text="moreLang.trueText"
        :cancel-button-text="moreLang.falseText"
        :columns="countryArr"
        item-height="1rem"
        value-key="content"
        @cancel="showcountryPicker = false"
        @confirm="selCountryConfirm"
      />
    </van-popup>

    <van-overlay :show="isShowWechatPop">
      <div class="van-dialog" @click.stop style="width: 76%">
        <div class="wechatPaycon">
          <div>{{ moreLang.wxPay }}</div>
          <div class="van-hairline--top fc-color-main" @click="completePay(1)">
            {{ moreLang.Completed }}
          </div>
          <div class="van-hairline--top" @click="completePay(2)">
            {{ moreLang.failedPay }}
          </div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="true" v-if="isShowGuide" @click="closeGuide">
      <div class="guide_item" :class="{ ar_lang: directionStyle == 'rtl' }" :style="{ top: pwaFlag ? '0.2rem' : '2.3rem' }">
        <div class="selTxt">{{ selCountryInfo.content }}</div>
        <div class="guide_desc">{{ moreLang.EnterIDTip }}</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { getUrlInfo, getLanguage } from '../tools/utils'
import "@vant/touch-emulator";
import {
  Picker,
  Toast,
  Popup,
  Overlay,
  Collapse,
  CollapseItem,
  Dialog,
  Image as VanImage,
} from "vant";
Vue.use(Picker);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Overlay);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dialog);
Vue.use(VanImage);
var _self;
import qs from 'qs';
import { BaseUrl } from "../main";

export default {
  name: "index",
  data() {
    return {
      //
      urlParams: null,
      hideReplaceBtn: false, //是否隐藏替换按钮
      language: "",
      phoneCountry: "", // 被充值用户的注册国家
      ipCountry: '', // 访问用户IP识别国家
      directionStyle: "ltr",
      apiUrl: BaseUrl, //测试
      // TODO 打包前记得改
      payPayUrl: "https://ppcb.chichat.info/faceshow", // 正式
      // payPayUrl: "https://api-test.tadachat.live/faceshow", //测试

      // newApiUrl: "http://tdtesth5.vvvps.com/faceshow", //新测试
      newApiUrl: "https://checkout.vvvps.com/faceshow", //新正式
      token: "",
      userId: "", //2120000508

      showIdDesc: false, //是否显示‘什么是fcid’
      selPayStyleId: null,
      selPayStyleNormId: null,

      userInfo: {},
      moreLang: {
        //payforType :'',
        trueText: "",
        falseText: "",
        alertShowTxt1: "",
        alertShowTxt3: "",
        alertShowTxt5: "",
        EnterIDTip: "",
        buyNoticeA: "",
        wxPay: "",
        Completed: "",
        failedPay: "",
      },
      currentCountryIndex: 0,
      currentCountry: "", //当前的国家语言
      cuntryCode: "", //国家code
      selCountryInfo: {},
      countryLoading: false, //加载中
      showcountryPicker: false,
      countryArr: [],

      payStyleArr: "",
      activePayIndex: null,

      isShowWechatPop: false, //是否显示微信回调弹窗
      tradeNo: "", //订单号

      isShowGuide: false,
      pwaFlag: false,  // 是否从pwa跳转过来
      pwaParmas: {},

      isChannelPackage: false, // 是否渠道包
    };
  },
  computed: {
    // 将 countryArr 和 phoneCountry 作为一个对象来监控
    countryData() {
      return {
        countryArr: this.countryArr,
        phoneCountry: this.phoneCountry
      };
    }
  },
  watch: {
    countryData(newVal) {
      const hasCountryArr = newVal.countryArr && newVal.countryArr.length
      if(!hasCountryArr) {
        return
      }
      // 渠道包：获取注册国家后 匹配
      if (newVal.phoneCountry) {
        this.pipeiCountry(newVal.countryArr);
      }
    },
    selCountryInfo(val) {
      //localStorage.setItem('selCountryInfo',JSON.stringify(val));
    },
  },
  filters: {},
  async created() {
    _self = this;

    // 先获取访问用户IP国家
    await _self.getVisitorIPCountry();

    let language = getLanguage();
    _self.language = language;
    _self.initUrlParams();
    // _self.textSize();
    _self.getUserInfo();
    _self.currentCountry = _self.getLang();
    _self.getMoreLang();
    /*
    let language = navigator.language || navigator.browserLanguage;
    */
      //_self.cuntryCode = language.substr(0,2);
    //_self.cuntryCode = language.split('-')[1];
    let thisCounty = "";

    if (language.split("-")[1]) {
      thisCounty = language.split("-")[1];
    } else {
      if (language.split("-")[0] == "zh") {
        thisCounty = "CN";
      } else {
        thisCounty = language.split("-")[0];
      }
    }
    _self.cuntryCode = thisCounty.toUpperCase();

    console.log('language', language);
    console.log('cuntryCode', _self.cuntryCode);
    if (language.indexOf("ar") > -1) {
      _self.directionStyle = "rtl";
    }
    //_self.currentCountry = language.split('-')[0];
    _self.getCountryList();
    _self.showWechatPopFun();

    let isFristEnter = localStorage.getItem("isFristEnter");
    if (isFristEnter == 1) {
      //1已经访问过
    } else {
      _self.isShowGuide = true;
    }
  },
  methods: {
    initUrlParams() {
      const urlParams = getUrlInfo();
      this.urlParams = urlParams;
      const { userId, pwaFlag, token, isChannelPackage } = getUrlInfo();
      // 渠道包：参数带 userId 的同步到 localStorage， getUserInfo 初始化需要使用
      if(userId) {
        localStorage.setItem("userId", userId);
        _self.hideReplaceBtn = true;
      }
      // 从tada pwa跳转过来
      if(pwaFlag === 'true') {
        const { callbackUrl, fromGame, activeTabIndex } = getUrlInfo();
        _self.pwaFlag = true;
        _self.pwaParmas = {pwaFlag, callbackUrl, fromGame, activeTabIndex};
      }

      // 获取toekn
      if(token) {
        _self.token = token;
      }

      // 渠道包：判断是否渠道包
      if(isChannelPackage === 'true') {
        _self.isChannelPackage = true;
        // 存入token、
      }
    },
    filterInput(event) {
      // 移除非数字字符，并限制长度为 11
      this.userId = event.target.value.replace(/\D/g, '').slice(0, 11);
    },
    //字体大小
    textSize() {
      !(function (a) {
        function b() {
          var b = g.getBoundingClientRect().width;
          (a.rem =
            b / 7.5 > 100 ? 100 : b / 7.5 < 300 / 7.5 ? 300 / 7.5 : b / 7.5),
            (g.style.fontSize = a.rem + "px");
          //a.rem = (b / 7.5), g.style.fontSize = a.rem + "px"
        }
        var g = a.document.documentElement,
          e;
        a.addEventListener(
          "resize",
          function () {
            clearTimeout(e), (e = setTimeout(b, 300));
          },
          !1
        ),
          a.addEventListener(
            "pageshow",
            function (a) {
              a.persisted && (clearTimeout(e), (e = setTimeout(b, 300)));
            },
            !1
          ),
          b();
      })(window);
    },
    //获取RUL参数值
    getUrlParam(fromeType) {
      var params = decodeURI(window.location.search);
      var reg = new RegExp("(^|&)" + fromeType + "=([^&]*)(&|$)");
      var r = params.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getLang() {
      /*
      let language = navigator.language || navigator.browserLanguage;
      */
      let language = this.language;
      console.log(language);
      if (
        language == "zh-MO" ||
        language == "zh_TW" ||
        language == "zh-HK" ||
        language == "zh-HANT-TW" ||
        language == "zh-HANT-HK" ||
        language.indexOf("zh-HANT") != -1
      ) {
        language = "zh-rHK";
      }
      if (language == "zh-CN" || language == "zh-CH" || language == "zh-AE") {
        language = "zh";
      }
      if (language == "de-DE") {
        language = "de";
      }
      if (language == "ar") {
        //$("html").css("direction", "rtl");
        var box = document.getElementById("app");
        box.style.direction = "rtl";
      }
      return language;
    },
    //关闭引导
    closeGuide() {
      _self.isShowGuide = false;
      localStorage.setItem("isFristEnter", 1);
    },

    //判断微信显示弹窗
    showWechatPopFun() {
      //判断是否有订单号
      let tradeNo = _self.getUrlParam("tradeNo");
      console.log(tradeNo);
      /*
      let language = navigator.language || navigator.browserLanguage;
      */
      let language = this.language;
      var lang = language.split("-")[0];
      console.log(lang);
      if (tradeNo) {
        _self.tradeNo = tradeNo;
        var IsWeChatPay = localStorage.getItem("IsWeChatPay");
        console.log(IsWeChatPay);
        console.log(lang);
        if (IsWeChatPay == "true" && lang == "zh") {
          //Toast('微信支付');
          _self.isShowWechatPop = true;
        }
      } else {
        localStorage.removeItem("IsWeChatPay");
      }
    },
    //退出登录
    exitLogin() {
      localStorage.setItem("userInfo", "");
      _self.$router.push({
        path: "/login",
      });
    },
    //切换账号
    replaceAccount() {
      localStorage.removeItem("userId");
      _self.userId = "";
      _self.userInfo = "";
    },
    //缓存读取用户信息
    getUserInfo(e) {
      if (e == 1) {
        //点击确定按钮
        if (_self.userId) {
          _self.getUserInfoById('change');
        } else {
          Toast(_self.$i18n.t("m.toastTips"));
        }
      } else {
        //初始化获取
        let userId = localStorage.getItem("userId");
        if (userId) {
          _self.userId = userId;
          _self.getUserInfoById();
        } else {
          _self.userId = "";
          _self.userInfo = "";
        }
      }
    },
    /**
     *
     * @param type change 点击确定按钮触发
     */
    getUserInfoById(type) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });
      let param = {
        userId: _self.userId,
      };
      this.$axios({
        method: "post",
        url: "/web/h5/getUserById",
        params: {
          param: JSON.stringify(param),
        },
      })
        .then((res) => {
          Toast.clear();
          // console.log(res);
          if (res.data.code == 1) {
            _self.userInfo = res.data.result;
            _self.userId = res.data.result.userId;
            _self.phoneCountry = res.data.result.phoneCountry;
            localStorage.setItem("userId", res.data.result.userId);
            if (type === 'change' && _self.countryArr.length) {
              this.pipeiCountry(_self.countryArr);
            }
          } else if (res.data.code == 3) {
            Toast(_self.$i18n.t("m.toastTips-no-exist"));
          } else {
            Toast(_self.$i18n.t("m.toastTips-no-exist"));
          }
        })
        .catch((error) => {
          Toast.clear();
          console.log(error);
        });
    },

    selCountryConfirm(val, index) {
      // console.log(val);
      localStorage.setItem("selCountryInfo", JSON.stringify(val));
      _self.currentCountryIndex = index;
      _self.selCountryInfo = val;
      _self.activePayIndex = null;
      _self.showcountryPicker = false;
      _self.getPayChannels(val.countryId);
    },
    getMoreLang() {
      _self.moreLang = {
        //payforType :_self.$i18n.t('m.payforType'),
        trueText: _self.$i18n.t("m.trueText"),
        falseText: _self.$i18n.t("m.falseText"),
        alertShowTxt1: _self.$i18n.t("m.alertShowTxt1"),
        alertShowTxt3: _self.$i18n.t("m.alertShowTxt3"),
        alertShowTxt5: _self.$i18n.t("m.alertShowTxt5"),
        EnterIDTip: _self.$i18n.t("m.EnterIDTip"),
        buyNoticeA: _self.$i18n.t("m.buy-notice-a"),
        wxPay: _self.$i18n.t("m.wxPay"),
        Completed: _self.$i18n.t("m.Completed"),
        failedPay: _self.$i18n.t("m.failedPay"),
      };
      // console.log(_self.moreLang);
      document.title = _self.$i18n.t("m.Diamonds_title");

      Dialog.setDefaultOptions({
        width: "76%",
        confirmButtonColor: "#008AFF",
        confirmButtonText: _self.moreLang.trueText,
        cancelButtonText: _self.moreLang.falseText,
      });
    },

    //获取当前地区
    getCountryList() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });
      _self.countryLoading = false;
      this.$axios({
        method: "POST",
        url: "/web/h5/getCountryList",
        params: {
          language: _self.currentCountry,
          //"systoken": _self.token
        },
      })
        .then((res) => {
          _self.countryLoading = false;
          if (res.data.code == 1) {
            _self.countryArr = res.data.result;
            // 非渠道包（即 官网直接进入）countryArr 有值就匹配
            if(!_self.hideReplaceBtn) {
              _self.pipeiCountry(res.data.result);
            }
          } else {
            // code
            //_self.exitLogin();
          }
        })
        .catch((error) => {
          console.log(error); //  错误处理 相当于error
          Toast("getCountryList Ajax error!");
        });
    },

    // 获取访问用户IP识别国家
    getVisitorIPCountry(){
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });
      return this.$axios({
        method: "get",
        url: "/web/h5/pay/getUserIpCountry"
      })
      .then((res) => {
        Toast.clear();
        if (res.data.code == 1) {
          this.ipCountry = res.data.result.ipCountry;
        }
      })
      .catch((error) => {
        Toast.clear();
        console.log(error);
      });
    },

    /*
    *  国家匹配逻辑
    *  历史选择国家 > 被充值用户注册国家 > 访问用户 IP 识别国家 > 美国（前三者返回的国家存在于国家列表中，才会触发命中，没触发命中走美国兜底）
    *  
    *  更换用户(包含路由中带的userId):历史选择国家 > 被充值用户注册国家 > 访问用户 IP 识别国家 > 美国（前三者返回的国家存在于国家列表中，才会触发命中，没触发命中走美国兜底）
    *  无用户：历史选择国家> 访问用户 IP 识别国家 > 美国（前二者返回的国家存在于国家列表中，才会触发命中，没触发命中走美国兜底）
    */
    pipeiCountry(arr) {
      let getInfo = localStorage.getItem("selCountryInfo");
      let cunCountryInfo = JSON.parse(getInfo);
      // console.log(cunCountryInfo);
      let aaa = "";
      // 上次选中的国家
      if (cunCountryInfo && cunCountryInfo.coding) {
        aaa = cunCountryInfo.coding;
      } else if(_self.phoneCountry) {
        // 被充值用户的注册国家
        aaa = _self.phoneCountry;
      } else {
        // 访问用户IP识别国家
        aaa = _self.ipCountry;
      }
      /* 这个 cuntryCode 基本没用，对也对不上
      else {
        aaa = _self.cuntryCode;
      }
      */

      var istrue = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].coding == aaa) {
          _self.currentCountryIndex = i;
          _self.selCountryInfo = arr[i];
          istrue = true;
          break;
        }
      }
      if (!istrue) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].coding == "US") {
            _self.currentCountryIndex = i;
            _self.selCountryInfo = arr[i];
            istrue = true;
            break;
          }
        }
      }

      _self.getPayChannels(_self.selCountryInfo.countryId);
      //getPayChannels(locationCountry.countryId,language);
    },

    // 获取单个国家下面的支付方法有哪些
    getPayChannels(countryId) {
      let cityID;
      if (countryId) {
        cityID = countryId;
      } else {
        cityID = _self.countryArr[_self.currentCountryIndex].countryId;
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });
      this.$axios({
        method: "post",
        url: "/web/h5/getPayChannels",
        data: qs.stringify({
          countryId: cityID,
          language: _self.currentCountry,
          //"systoken": _self.token
        }),
       headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
        .then((res) => {
          Toast.clear();
          if (res.data.code == 1) {
            _self.payStyleArr = res.data.result.filter(v => v.rechargePayType);
          } else {
            //_self.exitLogin();
          }
        })
        .catch((error) => {
          console.log(error); //  错误处理 相当于error
          Toast("getPayChannels Ajax error!");
        });
    },

    payforMoney(item, info) {
      if (!_self.userId) {
        //Toast(_self.$i18n.t('m.toastTips'));
        Toast({
          message: _self.$i18n.t("m.toastTips"),
          position: "top",
        });
        return false;
      }
      let payPlatformId = item.id;
      console.log(item);
      let price;
      if (_self.selCountryInfo.coding == "CN") {
        price = "￥" + info.price_China;
      } else {
        price = "$" + info.price_America;
      }

      Dialog.confirm({
        message:
          _self.moreLang.alertShowTxt1 +
          " " +
          price +
          " " +
          _self.moreLang.alertShowTxt3 +
          " " +
          info.number +
          " " +
          _self.moreLang.alertShowTxt5,
      })
        .then(() => {
          // on confirm
          if (
            item.payTypeName == "Visa & MasterCard"
            || item.payTypeName == "TapPayments"
          ) {
            _self.selPayStyleId = payPlatformId;
            _self.selPayStyleNormId = info.rechargeNormId;
            // _self.emailShow = true;

            //  _self.$router.push({ name: 'news', params: { userId: 123 }});
            
            let params = {
                userId: _self.userId,
                selPayStyleId: payPlatformId,
                selPayStyleNormId: info.rechargeNormId,
                countryCode: _self.selCountryInfo.coding,
                payTypeName: item.payTypeName,
                nickName: _self.userInfo.nickName,
            }
            if(_self.pwaFlag ){
              params.pwaFlag = _self.pwaFlag
            }
            _self.$router.push({
              name: "email",
              params: params,
            });
          } else {
            let url = item.payTypeName == "PayPal"? _self.payPayUrl : _self.apiUrl
            // 针对paymentwall-paypal、applepay、googlepay方式特殊处理中转
            const speicalPaytypeArr = ['paypal','googlepay','applepay'];
            if(( item.payTypeAgentCode && speicalPaytypeArr.includes(item.payTypeAgentCode.toLowerCase())) && item.typeId === 12 ){
              url = _self.newApiUrl;
            }
            _self.createOrderPay(payPlatformId, info.rechargeNormId, url );
          }
        })
        .catch(() => {
          // on cancel
        });
    },

    createOrderPay(payPlatformId, rechargeId, urlPre) {
      if (payPlatformId == 2) {
        localStorage.setItem("IsWeChatPay", "true");
      } else {
        localStorage.setItem("IsWeChatPay", "false");
      }
      var param = {
        //"systoken": _self.token,
        userId: _self.userId,
        rechargeId: rechargeId,
        countryCode: _self.selCountryInfo.coding,
      };
      // 如果是从pwa页面跳转过来的，则需要添加这个参数，充值成功后返回到pwa的水晶兑换页面
      if(_self.pwaFlag){
        param.callbackUrl= decodeURIComponent(`${_self.pwaParmas.callbackUrl}?fromGame=${_self.pwaParmas.fromGame}&activeTabIndex=${_self.pwaParmas.activeTabIndex}`)
      }
      
      // 如果是从渠道包-钱包-H5支付过来，需要添加这个参数，充值成功后返回到H5支付-带币商tab的页面
      if(_self.isChannelPackage){

        const callbackUrl = window.location.origin+
          '/#/?token='+_self.token+
          '&userId='+_self.userId+
          '&isChannelPackage='+_self.isChannelPackage+
          '&language='+ _self.language;

        param.callbackUrl= callbackUrl;
        // console.log(callbackUrl, 'callbackUrl');
      }
      // console.log(JSON.stringify(param));
      // return false;
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });

      // this.$axios({
      //   method: "post",
      //   url: "/web/h5/pay/createOrder",
      //   params: {
      //     param: JSON.stringify(param),
      //   },
      // })
      this.$axios.post(
        '/web/h5/pay/createOrder',
        param
      )
        .then((res) => {
          Toast.clear();
          if (res.data.code == 1) {
            var tradeNo = res.data.result.tradeNo;
            //跳转第三方
            // if (payPlatformId == 3) {
            //   //3 代表paypal
            //   window.location.href =
            //     _self.paypalUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            // } else { // }
            if (tradeNo == null || tradeNo == "") {
              Dialog.alert({
                message: "Transaction failed: system abnormal",
                confirmButtonText: "OK",
              });
            } else {
              // 如果是 Razer Gold Wallet支付（97：是测试环境的id，157是线上环境的id）&& 是从pwa入口进来的，则需要弹窗新的窗口。从而解决了CSP（内容安全策略）错误问题
              if((payPlatformId === 97 || payPlatformId === 157) && _self.pwaFlag){
                window.open(urlPre + "/web/h5/pay/start?tradeNo=" + tradeNo)
                return
              }
              window.location.href =
                urlPre + "/web/h5/pay/start?tradeNo=" + tradeNo;

            }
          } else if (res.data.code == 6000 || res.data.code == 90000) {
            Dialog.alert({
              message: "Transaction failed: system abnormal",
              confirmButtonText: "OK",
            }).then(() => {
              // on close
            });
          } else if (res.data.code === 90005) {
            Dialog.alert({
              message: "Transaction failed: system abnormal",
              confirmButtonText: "OK",
            }).then(() => {
              // on close
            });
          } else if (res.data.code == 0) {
            //_self.exitLogin();
          }
        })
        .catch((error) => {
          console.log(error); //  错误处理 相当于error
          Toast("getPayChannels Ajax error!");
        });
    },
    //微信用，确认是否支付完成
    completePay(e) {
      //e==1 已完成支付 2支付遇到问题
      localStorage.removeItem("IsWeChatPay");
      let param = {
        tradeNo: _self.tradeNo,
        //"systoken": _self.token
      };

      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: "static/img/loading.gif",
        className: "loading",
      });
      this.$axios({
        method: "post",
        url: "/web/h5/pay/alreadyPay",
        params: {
          param: JSON.stringify(param),
        },
      })
        .then((res) => {
          _self.isShowWechatPop = false;
          // console.log(res.data);
          if (res.data.code == 1) {
            var tradeNo = res.data.result.tradeNo;
            var alreadyPay = res.data.result.alreadyPay;
            //e==1 已完成支付 2支付遇到问题
            if (e == 1) {
              if (alreadyPay == 1) {
                _self.$router.push({
                  path: "/success",
                });
              } else {
                Toast({
                  message: _self.$i18n.t("m.toastTips-no-complete"),
                  duration: 3000,
                });
              }
            } else {
              if (alreadyPay == 1) {
                _self.$router.push({
                  path: "/success",
                });
              } else if (alreadyPay == 0) {
                //跳转第三方
                window.location.href =
                  _self.apiUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
              }
            }
          } else {
            //_self.exitLogin();
            Toast(res.data.msg);
          }
        })
        .catch((error) => {
          console.log(error); //  错误处理 相当于error
          Toast(JSON.stringify(error));
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/index.vue